import { render, staticRenderFns } from "./Abonements.vue?vue&type=template&id=4faf3ad2"
import script from "./Abonements.vue?vue&type=script&lang=js"
export * from "./Abonements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports